import { createRequest } from './base';

export const request = createRequest({
  baseURL: `${process.env.REACT_APP_AUTH_URL}/api`,
});
